<template>
  <div class="wrap">
    <div class="container">
      <div class="order_completed">
        <div class="order_page">주문 실패</div>

        <div class="order_res">
          <!-- <div class="img">
            <img src="/assets/images/layout/order_failed.png" />
          </div> -->

          <div class="txt">
            주문이 정상적으로 완료되지 않았습니다.
            <p>이용에 불편을 드려 죄송합니다.</p>
          </div>
        </div>

        <div class="order_info">
          <div class="nl">
            <div>결제 실패 사유</div>
            <div class="f_13">
              {{ completDatas.resMsg }}({{ completDatas.resCode }})
            </div>
          </div>
        </div>

        <div class="order_btn">
          <div class="btns orange" @click="handleOrderAgain">다시 주문하기</div>
          <!--  다시 주문결제 페이지로 이동. -->
          <div class="btns" @click="handleMoveContent">콘텐츠 페이지로</div>
          <!-- 구매하려했던 콘텐츠 페이지로 이동 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'OrderFailed',
  components: {
    //
  },
  setup() {
    const router = useRouter()

    const redirectIfFailed = localStorage.getItem('redirectIfFailed')
    const storageDatas = localStorage.getItem('orderCompletedData')
    const completDatas = JSON.parse(storageDatas)
    // const orderAgain = ref(false)
    // const moveContent = ref(false)
    const moveToUrl = (url) => {
      router.push({ path: url })
    }

    const handleOrderAgain = () => {
      // orderAgain.value = true
      router.push('/order') // /order 페이지로 리다이렉트
    }

    const handleMoveContent = () => {
      // moveContent.value = true
      if (redirectIfFailed) {
        window.location.href = redirectIfFailed
        localStorage.removeItem('redirectIfFailed')
        // router.push(redirectIfFailed) // redirectIfFailed에 저장된 URL로 리다이렉트
      } else {
        router.push('/contents') // 기본적으로 /contents 페이지로 리다이렉트
      }
    }

    return {
      moveToUrl,
      completDatas,
      // orderAgain,
      // moveContent,
      redirectIfFailed,

      handleOrderAgain,
      handleMoveContent,
    }
  },
}
</script>

<style></style>
